export enum LabelTypeEnum {
    CRITICAL = 'critical',
    DANGER = 'danger',
    DARK_RED = 'darkRed',
    SUCCESS = 'success',
    MEDIUM = 'medium',
    YELLOW = 'low',
    LOW = 'low',
    ORANGE = 'orange',
    GREEN = 'green',
    LIGHT_YELLOW = 'lightYellow',
    LIGHT_GRAY = 'lightGray',
    DARK_GRAY = 'darkGray',
    GREY = 'grey',
    DEV1 = 'dev1',
    DEV2 = 'dev2',
    DEV3 = 'dev3',
    UPDATED = 'updated',
    BLUE = 'blue1',
    INVALID = 'invalid',
    VIVID_VIOLET = 'vividViolet',
    AI_DEFAULT = 'aiDefault',
    LAVENDAR_500 = 'lavendar500'
}
export enum LabelModeEnum {
    GridMode = 'mode-grid',
    DefaultMode = 'mode-default',
    EntityMode = 'mode-entity'
}
